import axios from 'axios';
import { aspAppointmentApi } from '@/config/index';

const client = axios.create({
	baseURL: aspAppointmentApi,
	timeout: 15000,
	headers: { 'Content-Type': 'application/json' }
});

// 外部预约接口免登录，禁止携带项目中的登录态和租户信息。
client.interceptors.request.use((config) => {
	const headers = { ...config.headers };
	delete headers.Authorization;
	delete headers.authorization;
	delete headers['tenant-id'];
	config.headers = headers;
	return config;
});

function unwrap(response) {
	const body = response.data;
	if (Number(body?.code) === 0) return body.data;

	const error = new Error(body?.message || body?.msg || '预约提交失败');
	error.code = Number(body?.code);
	error.data = body?.data;
	throw error;
}

function handleError(error) {
	if (error?.response?.data) {
		try {
			unwrap(error.response);
		} catch (businessError) {
			return Promise.reject(businessError);
		}
	}

	if (error?.message === 'Network Error') {
		return Promise.reject(new Error('网络异常或接口跨域被拦截，请稍后重试'));
	}
	if (error?.code === 'ECONNABORTED') {
		return Promise.reject(new Error('预约请求超时，请稍后重试'));
	}
	return Promise.reject(error);
}

export default {
	create(data) {
		return client.post('/api/asp/appointments', data).then(unwrap).catch(handleError);
	}
};
